import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lazysizes'
import VueMeta from 'vue-meta'
import './plugins/vue-register-base-components'
import './plugins/google-analytics'

// Vue.config.productionTip = false

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
